import { useQuerySortedProviders } from '../../../hooks/API/useQueryProviders';
import { createMockEntitiesArray } from '../../../utils/collectionAdapters';
import { COUNT_PROVIDERS_NAVIGATION_LINKS } from '../utils';

export const useProviders = (queryOptions = {}) => {
  const query = useQuerySortedProviders({}, queryOptions);

  const collection = query.isLoading
    ? createMockEntitiesArray(COUNT_PROVIDERS_NAVIGATION_LINKS)
    : query.data?.items.slice(0, COUNT_PROVIDERS_NAVIGATION_LINKS);

  return { collection, query };
};
